import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function StoriesPage() {
  const [stories, setStories] = useState([]);
  useEffect(() => {
    api.get("/stories").then((r) => setStories(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="stories-page" className="min-h-screen bg-[var(--bone)] text-[var(--ink)]">
      <Nav />
      <section className="pt-40 pb-24">
        <div className="container-x">
          <div className="overline text-[var(--terracotta)]">Stories from the field</div>
          <h1 className="font-serif text-5xl md:text-7xl mt-4 tracking-[-0.025em] leading-[1.0] max-w-4xl">
            The numbers above are just numbers. <em className="text-[var(--terracotta)] not-italic">These are the people inside them.</em>
          </h1>
        </div>
      </section>
      <section className="pb-32">
        <div className="container-x grid grid-cols-12 gap-10">
          {stories.map((s, i) => (
            <article key={s.id} data-testid={`stories-page-card-${i}`} className={`col-span-12 ${i % 3 === 0 ? "md:col-span-7" : "md:col-span-5"}`}>
              <div className="overflow-hidden mb-6">
                <img src={s.image_url} alt={s.title} className="w-full h-[300px] md:h-[420px] object-cover" />
              </div>
              <div className="overline text-[var(--terracotta)]">{s.location}</div>
              <h2 className="font-serif text-3xl md:text-4xl mt-3 tracking-[-0.02em] leading-tight">{s.title}</h2>
              <p className="text-[var(--ink)]/75 mt-4 leading-relaxed">{s.excerpt}</p>
              <p className="text-sm text-[var(--muted)] mt-4">— {s.author}</p>
            </article>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
